/**
 * Regra única: quem recebe o Auto Ads.
 *
 * SÓ visitante anônimo. Ninguém logado vê anúncio — nem Premium, nem admin,
 * nem conta grátis.
 *
 * Por que a conta grátis também fica de fora: a área logada tem uma sidebar
 * fixa, e o Auto Ads do Google posiciona "side rails" na margem da tela. Os dois
 * disputam o mesmo canto e o anúncio acaba cobrindo a sidebar. Como todo o
 * tráfego de anúncio que importa é anônimo (SEO, links), servir Auto Ads apenas
 * pra quem não está logado elimina a colisão pela raiz: quem tem sidebar nunca
 * vê anúncio, e quem vê anúncio (anônimo) nunca tem sidebar.
 */
export function shouldShowAds(user: { plano?: string; role?: string } | null | undefined): boolean {
  return !user
}
